<div class="container-filtro">
    <img class="icon" [src]="dadosSelect.urlImg" type="image/svg+xml"/>
    <select id="filtro-tipo" class="filtro-tipo crud-select form-select" (change)="pegarValorAtual($event)">
        <option value="null" selected>{{dadosSelect.label}}</option>
        <option *ngFor="let dado of dadosSelect.opcoes" [value]="dado.id">{{ dado.label }}</option>
    </select>
</div>